import { round2, vals } from "@/lib/format";

export const round3 = (n) => Math.round((Number(n) || 0) * 1000) / 1000;
export const scaleCfg = (shop) => ({
  mode: shop?.scale_mode || "price", prefix: String(shop?.scale_prefix || "21").slice(0, 2),
  decimals: Number(shop?.price_decimals ?? 0), roundTo: Number(shop?.round_to) || 1,
});

export const weighPrice = (kg, ppk, shop) => {
  const step = scaleCfg(shop).roundTo;
  return round2(Math.round((Number(kg) * Number(ppk)) / step) * step);
};

export const ean13Check = (d12) => (10 - ([...d12].reduce((s, c, i) => s + Number(c) * (i % 2 ? 3 : 1), 0) % 10)) % 10;

export function makeScaleBarcode(product, kg, total, shop) {
  const c = scaleCfg(shop);
  const value = c.mode === "weight" ? Math.round(kg * 1000) : Math.round(total * 10 ** c.decimals);
  if (!product.plu || value > 99999 || value < 0) return null;
  const d12 = `${c.prefix}${String(product.plu).padStart(5, "0").slice(-5)}${String(value).padStart(5, "0")}`;
  return d12 + ean13Check(d12);
}

// Returns { product, kg, total } for a label printed by a scale (or by Dukkan), else null
export function parseScaleBarcode(code, shop, products) {
  const c = scaleCfg(shop);
  if (!/^\d{13}$/.test(code) || !code.startsWith(c.prefix) || ean13Check(code.slice(0, 12)) !== Number(code[12])) return null;
  const plu = code.slice(2, 7);
  const value = Number(code.slice(7, 12));
  const product = vals(products).find((p) => !p.deleted && p.sold_by_weight && String(p.plu || "").padStart(5, "0") === plu);
  if (!product) return null;
  if (c.mode === "weight") {
    const kg = round3(value / 1000);
    return { product, kg, total: weighPrice(kg, product.price, shop) };
  }
  const total = round2(value / 10 ** c.decimals);
  return { product, kg: product.price > 0 ? round3(total / product.price) || 0.001 : 1, total };
}

export const nextPlu = (products) => String(vals(products).reduce((m, p) => Math.max(m, Number(p.plu) || 0), 0) + 1).padStart(5, "0");

export const weighedLine = (p, kg, total) => ({ product_id: p.id, name: p.name, price: total / kg, cost: p.cost || 0, qty: kg, ppk: p.price, unit: "kg" });
